import "./list.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import DatatableRooms from "../../components/datatableRooms/DatatableRooms"


const Rooms = () => {
  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar/>
        <DatatableRooms/>
      </div>
    </div>
  )
}

export default Rooms